<template>
  <div v-if="termsConfig.show">
    <Checkbox
      v-if="termsConfig.required"
      v-model="accepted"
      :label="termsConfig.label"
    />
    <span
      v-else
      v-html="termsConfig.label"
      :style="{ 'font-size': '15px' }"
    ></span>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Checkbox: () => import('@/components/ui/Checkbox.vue')
  },
  data () {
    return {
      accepted: false
    }
  },
  computed: {
    termsConfig () {
      return this.$organization.termsAndConditionsConfig()
    }
  },
  watch: {
    accepted (val) {
      this.$emit(val ? 'accepted' : 'declined')
    }
  }
})
export default class TermsAndConditions extends Vue {
  mounted () {
    this.accepted = !this.termsConfig.show || !this.termsConfig.required
  }
}
</script>
